<template>
  <div id="carouselContainer" :class="[backgroundClass]">
    <div style="display: none;">
      <img src="assets/images/carousel/bg1.png" alt="">
      <img src="assets/images/carousel/bg2.png" alt="">
      <img src="assets/images/carousel/bg3.png" alt="">
    </div>
    <transition enter-active-class="animated slideInDown" leave-active-class="animated fadeOutDownBig">
      <div class="carousel" key="zero" v-if="itemState === 'zero'">
        <div class="carousel-cell">
          <div class="carousel-text">
            <h1>{{ t('headlineZeroTitle') }}</h1>
            <p>{{ t('headlineZeroDescp') }}</p>
            <a class="explore-more-btn" href="./docode.html">EXPLORE MORE</a>
          </div>
        </div>
        <div class="carousel-cell">
          <img width="60%" src="assets/images/carousel/item0.png" alt="">
        </div>
      </div>
      <div class="carousel" key="one" v-if="itemState === 'one'">
        <div class="carousel-cell">
          <div class="carousel-text">
            <h1>{{ t('headlineOneTitle') }}</h1>
            <p>{{ t('headlineOneDescp') }}</p>
          </div>
        </div>
        <div class="carousel-cell">
          <img width="70%" src="assets/images/carousel/item1.png" alt="">
        </div>
      </div>
      <div class="carousel" key="two" v-if="itemState === 'two'">
        <div class="carousel-cell">
          <div class="carousel-text">
            <h1>{{ t('headlineTwoTitle') }}</h1>
            <p>{{ t('headlineTwoDescp') }}</p>
          </div>
        </div>
        <div class="carousel-cell">
          <img width="70%" src="assets/images/carousel/item2.png" alt="">
        </div>
      </div>
      <div class="carousel" key="three" v-if="itemState === 'three'">
        <div class="carousel-cell">
          <div class="carousel-text">
            <h1>{{ t('headlineThreeTitle') }}</h1>
            <p>{{ t('headlineThreeDescp') }}</p>
          </div>
        </div>
        <div class="carousel-cell">
          <img width="70%" src="assets/images/carousel/item3.png" alt="">
        </div>
      </div>
    </transition>
    <ol class="carousel-indicators">
      <li v-for="(hl, hidx) in headlines" :class="{ 'active': hl.active }" @click="changeHeadline(hidx, hl)">
        <i class="en" :class="[hl.iconClass]" aria-hidden="true"></i>
      </li>
    </ol>
  </div>
</template>
<script>
  export default {
    name: 'CarouselNew',
    data() {
      return {
        interval: 10000,
        backgroundClass: 'bg-zero',
        itemState: 'zero',
        count: 0, // 当前展示的项的索引
        intervalID: undefined,
        headlines: [{
          active: true,
          title: 'headlineZeroTitle',
          description: 'headLineZeroDescp',
          imageURL: 'assets/images/carousel/item0.png',
          iconClass: 'en-docode',
          state: 'zero',
        }, {
          title: 'headlineOneTitle',
          description: 'headLineOneDescp',
          imageURL: 'assets/images/carousel/item1.png',
          iconClass: 'en-qr-code',
          state: 'one',
        },
        {
          title: 'headlineTwoTitle',
          description: 'headLineTwoDescp',
          imageURL: 'assets/images/carousel/item2.png',
          iconClass: 'en-user',
          state: 'two',
        },
        {
          title: 'headlineThreeTitle',
          description: 'headLineThreeDescp',
          imageURL: 'assets/images/carousel/item3.png',
          iconClass: 'en-bar-chart',
          state: 'three',
        }],
      };
    },
    methods: {
      changeHeadline(index, headline) {
        this.count = index;
        this.switchHeadline(headline);
        this.restartInterval();
      },
      switchHeadline(headline) {
        for (let hl of this.headlines) {
          this.$set(hl, 'active', false);

        }
        this.$set(headline, 'active', true);
        this.backgroundClass = `bg-${headline.state}`;
        this.itemState = headline.state;
      },
      restartInterval() {
        if (this.intervalID) {
          clearInterval(this.intervalID);
        }

        this.intervalID = setInterval(this.slideInterval, this.interval);
      },
      slideInterval() {
        this.count += 1;
        for (let hl of this.headlines) {
          this.$set(hl, 'active', false);
        }

        const length = this.headlines.length;
        this.switchHeadline(this.headlines[this.count % length]);
      }
    },
    created() {
      this.restartInterval();
    },
    destroyed() {
      if (this.intervalID) {
        clearInterval(this.intervalID);
      }
    },
    locales: {
      en: {
        headlineZeroTitle: 'Make change, take mobile',
        headlineZeroDescp: `The easiest way to accept QR Code payment in the world, seamless and effortless.`,
        headlineOneTitle: 'New standard and trend',
        headlineOneDescp: `QR code is not a strange concept,while making payment with QR code is a new area in payment industry. Everonet establishes a new standard and invents more product concepts in QR payment industry. Making QR payment easy and touchable
            to everyone.`,
        headlineTwoTitle: 'Amazing rapid growth',
        headlineTwoDescp: `Simple, convenient, and easy to learn, those features makes QR payment a new but widely accepted concept worldwide.
            The growth of 50% per year amazes everyone. You may experience QR payment at the every corner of the world, It
            is no longer a dream that travelling around by taking a phone and scanning QR code.`,
        headlineThreeTitle: 'Far beyond payment',
        headlineThreeDescp: `QR payment makes all in one more feasible, more functions like coupons, red packet, discount can be combined with
            payment by just a simple scan, gone are the days for the complex procedures.`,
      },
      jp: {
        headlineZeroTitle: 'Make change, take mobile',
        headlineZeroDescp: `The easiest way to accept QR Code payment in the world, seamless and effortless.`,
        headlineOneTitle: '新基準とトレンド',
        headlineOneDescp: `QRコードは決して新しいものではありませんが、決済領域に利用されたのは最近の動きです。Everonetは標準ソリューションの提供により、QRコード決済の複雑さを軽減しました。今後も容易に導入できることを努力していきます。`,
        headlineTwoTitle: '急速の成長',
        headlineTwoDescp: `シンプル、便利、学び易いという特徴があり、QRコード決済は市場に素早く認めた新しい決済方式となりました。現在平均５０％の成長率で人々に驚かれました。近い未来、QRコード決済は世界の隅々で体験できるようになり、ただ一台のモバイルで世界周遊することはもはや夢ではないです。`,
        headlineThreeTitle: 'ペイメントを凌ぐ',
        headlineThreeDescp: `シンプルなQRコードはそれ以上の機能が備えられます。クーポン、お年玉、ポイント等簡単にスキャンすることによって機能が実現されます。以前の複雑な業務処理が不要となります。`,
      }
    }
  };

</script>
<style lang="less">
  #carouselContainer {
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  
  .carousel {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: table;
    height: 100%;
    width: 100%;
    >.carousel-cell {
      position: relative;
      display: table-cell;
      vertical-align: middle;
      &:first-child {
        width: 55%;
      }
      &:last-child {
        width: 45%;
      }
    }
  }
  
  .carousel-text {
    color: #FFF;
    padding-left: 20%;
    padding-right: 96px;
    >h1 {
      white-space: nowrap;
      margin-bottom: 54px;
      font-family: Helvetica Inserat LT;
      font-weight: lighter;
      letter-spacing: 2.2px;
      font-size: 40px;
    }
    >p {
      line-height: 26px;
      font-size: 14px;
      letter-spacing: 1px;
      font-weight: 100;
    }
  }
  
  .carousel-indicators {
    margin-right: 36px;
    position: absolute;
    right: 0;
    top: 40%;
    >li {
      list-style: none;
      margin-bottom: 12px;
      color: #7AEBFF;
      height: 51px;
      width: 30px;
      padding-right: 10px;
      line-height: 50px;
      border-right: 4px solid #7AEBFF;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
      &.active {
        color: #FFF;
        border-color: #FFF;
      }
    }
  }
  
  .explore-more-btn {
    background-color: #23BACE;
    font-size: 14px;
    color: #FFF;
    line-height: 50px;
    height: 50px;
    text-decoration: none;
    width: 202px;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    margin-top: 68px;
    display: inline-block;
    text-align: center;
  }
  
  .bg-zero {
    background-image: url('/assets/images/carousel/bg0.png');
  }
  
  .bg-one {
    background-image: url('/assets/images/carousel/bg1.png');
  }
  
  .bg-two {
    background-image: url('/assets/images/carousel/bg2.png');
  }
  
  .bg-three {
    background-image: url('/assets/images/carousel/bg3.png');
  }
</style>


// WEBPACK FOOTER //
// CarouselNew.vue?4dc206b2